type FieldErrorProps = {
  message?: string | string[]
  className?: string
}

export function FieldError({ message, className = '' }: FieldErrorProps) {
  if (!message || (Array.isArray(message) && message.length === 0)) return null
  const text = Array.isArray(message) ? message.join('、') : message
  return <p className={`text-xs text-danger-300 ${className}`.trim()}>{text}</p>
}
